module.exports = __webpack_public_path__ + "static/media/github-circle.6e7b041e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/github-circle.svg
// module id = 30
// module chunks = 0